<template>
  <div class="content-contrainer">
    <div class="content-banner" :class="__lang"></div>
    <div class="content-menu-list">
      <div class="main-box">
        <router-link v-for="(item, index) in childrenMenu.child" :key="index" :to="item.link" class="content-menu-list-item" active-class="active">{{item.name}}</router-link>
      </div>
    </div>
    <html404 v-if="content===null"></html404>
    <div v-else>
      <block :title="content.title">
        <div class="main-box" style="margin-top: 50px;">
          <h2>{{content.child.name}}</h2>
          <div style="padding:20px; background-color: #eee; margin-top: 30px;">
            <el-row>
              <el-col :span="6">
                学历要求：{{content.child.data.education}}
              </el-col>
              <el-col :span="6">
                工作经验：{{content.child.data.workExp}}
              </el-col>
              <el-col :span="6">
                薪资待遇：{{content.child.data.salary}}
              </el-col>
            </el-row>
          </div>
          <h4>岗位职责</h4>
          <ol class="yw-list-1">
            <li v-for="(val, index) in content.child.data.duty" :key="index">{{val}}</li>
          </ol>
          <el-divider></el-divider>
          <h4>岗位要求</h4>
          <ol class="yw-list-1">
            <li v-for="(val, index) in content.child.data.requirement" :key="index">{{val}}</li>
          </ol>
          <div class="zp-footer">
            <el-row>
              <el-col :span="2">
               <el-image
                style="width: 50px; margin-top:8px;margin-left:10px;"
                :src="require('../../assets/img/jrwm_laba.png')"
                fit="contain"
               ></el-image>
              </el-col>
              <el-col :span="21">
                <p style="font-size: 14px;margin:10px 0 5px 0;">请以“应聘岗位+姓名+学校+专业”命名简历并附上个人资料（身份证、学历、学位证书、职业资格证书、学术成果、获奖证明等）发送至下方邮箱。</p>
                <el-row style="font-size: 14px;">
                  <el-col :span="8"><b>邮件标题注明：应聘岗位+姓名+学校+专业</b></el-col>
                  <el-col :span="8"><b>联系电话： 0756-6348482</b></el-col>
                  <el-col :span="8"><b>报名邮箱：chiefhr@chiefdata.org</b></el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </div>
      </block>
    </div>
  </div>
</template>

<script>
import { navbar, join as data } from "../../data.js";
import lang from "../../lang.js";
import block from "../../components/block.vue";
import html404 from "../../components/404.vue";
export default {
  name: "joindetail",
  components:{
    block,
    html404
  },
  data() {
    return {
      lang,
      data,
      active:0
    };
  },
  computed:{
    menus(){
      return navbar({
        lang:this.$route.params.lang || 'zh-CN'
      })
    },
    childrenMenu(){
      return this.menus.find(v=>v.id=="join");
    },
    __lang(){return this.$route.params.lang},
    content(){
      const lang = this.__lang;
      const __data= {};
      const params = this.$route.params;
      const parentInfo = data[lang].data.find(v=>v.id==params.id);
      console.log(data[lang].data);
      if (parentInfo) {
        __data.title = parentInfo.name;
        const childInfo = parentInfo.child.find(v=>v.id==params.childid);
        if (childInfo) {
          __data.child = childInfo;
        } else {
          __data.child = {};
        }
      } else {
        __data.title = "";
      }
      return __data;
    },
    routeName(){
      return this.$route.name;
    }
  },
  created(){
    console.log(this.content);
  }
};
</script>

<style lang="less" scoped>
.content-contrainer {
  padding-bottom: 60px;
}
.content-banner {
  margin-top: 70px;
  width: 100%;
  height: 340px;
  background: url(../../assets/img/banner_jiaru.jpg) center center no-repeat;
  &.en {
    background: url(../../assets/img/banner_jiaru_en.png) center center no-repeat;
  }
}
.content-menu-list {
  border-bottom: 1px solid #999;
  overflow: hidden;
  .content-menu-list-item {
    text-decoration: none;
    color: #222;
    float: left;
    line-height: 60px;
    font-size: 16px;
    padding: 0 20px;
    &.active{
      color: #d22c1d;
    }
    &.active:after {
      display: block;
      content: " ";
      width: 60%;
      height: 4px;
      background-color: #d22c1d;
      margin: auto;
    }
  }
}
.filed-desc {
  padding: 40px 0;
  line-height: 30px;
  font-size: 18px;
}
.labor-checkbox {
  margin-bottom: 40px;
  .labor-checkbox-btn {
    display:block;
    width: 100%;
    text-align: center;
    line-height: 60px;
    height: 60px;
    padding: 0;
    background-color: #eee;
    color: #222;
    text-decoration: none;
    border-radius: 0;
    font-size: 18px;
    .icon {
      width: 36px;
      display: inline-block;
      height: 100%;
      vertical-align:
      middle;margin-right: 10px;
    }
    .icon1 {
      display: none;
    }
    .icon2{
      display: inline-block;
    }
    &.active{
      color: #fff;
      background-color: #d22c1d;
      .icon2 {
        display: none;
      }
      .icon1{
        display: inline-block;
      }
    }
  }
}
.st-desc {
  position: relative;
  .text1-box {
    position: absolute;
    top: 0;
    left: 130px;
    right: 143px;
    margin: 100px auto;
    height: 130px;
    .icon{
      margin-top: 20px;
      margin-left: 100px;
      margin-right: 50px;
      float: left;
    }
    p{
      color: #fff;
      margin-top: 20px;
      margin-right: 50px;
      line-height: 1.8;
    }
  }
}
.databox {
  margin-top: 20px;
}
.datacontent {
  img{
    width: 100%;
  }
}
.yw-list-1 {
  padding-left: 20px;
  li{
    padding:5px 0;
  }
}
.zp-footer{
  margin-top: 50px;
  padding: 15px 40px;
  background-color: #eee;
}
</style>
